<section class="back-cont-alert-location">
  <section class="main-location-map">
    <div class="top-cont">
      <span class="main-message">{{
        labels.stellar.sdfcard.locationMaps.notification.searchNoResult
      }}</span>
      <span class="secondary-text">{{
        labels.stellar.sdfcard.locationMaps.notification.tryAgainFuture
      }}</span>
    </div>
    <div class="bottom-cont">
      <div class="btn-cont btn-ok" (click)="onClose()">
        {{ labels.stellar.ok }}
      </div>
    </div>
  </section>
</section>
